(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksController', KiosksController);

    KiosksController.$inject = ['$scope', '$state', 'Kiosks', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function KiosksController ($scope, $state, Kiosks, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        // vm.applyFilter = applyFilter;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "kiosks";
        vm.currentStateFilter = "kiosks-filter";
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        vm.kiosk = {};
        localStorage.setItem("kiosk-dashboard-kiosk", JSON.stringify(vm.kiosk));

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };


            Kiosks.query(body, onSuccess, onError)
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.kiosks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }


        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

        vm.editKiosk = function(kiosk) {
            $state.transitionTo("kiosks-dashboard-kiosk", {
                selectedDashboards : kiosk.dashboards,
                kiosk : kiosk
            }, {location: "replace"});
        }

    }
})();
